import { SxStyles } from '../../../../../types';
import theme from '../../../../../theme';
import { getResponsiveSize } from '../../../../../utils';

export const PsylarisPanelStyle: SxStyles = {
  psylarisContainer: {
    width: '100%',
    padding: 0,
    margin: 0,
    position: 'relative',

    '& .top-container': {
      display: 'flex',
      justifyContent: 'center',
      paddingTop: getResponsiveSize(30),
      paddingBottom: getResponsiveSize(30),
      borderBottom: `1px solid ${theme.palette.neutral?.grey8}`,
      position: 'relative',

      '& .top-container_title': {
        textTransform: 'capitalize',
        fontFamily: theme.typography.mainFontFamily,
        fontSize: getResponsiveSize(16.5),
        minHeight: 0,
        minWidth: 0,
        padding: 0,
        color: '#2392BA',
        fontWeight: '700',
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
      },
      '& .apply-list': {
        position: 'absolute',
        top: '50%',
        left: '6%',
        transform: 'translate(-50%, -50%)',
        '& .list-button': {
          '& .list': {
            height: getResponsiveSize(24),
            width: getResponsiveSize(24),
          },
          '& .list-selected': {
            color: '#2392BA',
            height: getResponsiveSize(24),
            width: getResponsiveSize(24),
          },
        },
      },
    },

    '& .apply-markets': {
      position: 'absolute',
      right: '1.5%',
      top: '1.5%',
      '& img': {
        height: getResponsiveSize(16),
      },
      '& .MuiFormControl-root': {
        '& .MuiSelect-select': {
          minHeight: '0px',
          padding: getResponsiveSize(14),
          borderColor: 'green',
        },

        '& .MuiSvgIcon-root': {
          display: 'none',
        },
      },
    },

    '& .content-container': {
      overflow: 'auto',
      overflowX: 'hidden',
      height: 'auto',
      maxHeight: getResponsiveSize(350),
      mr: getResponsiveSize(10),
      p: getResponsiveSize(20),
      '&::-webkit-scrollbar': {
        width: 4,
      },
      '&::-webkit-scrollbar-track': {
        webkitBorderRadius: '100px',
        borderRadius: '100px',
        m: getResponsiveSize(10),
      },
      '&::-webkit-scrollbar-thumb': {
        webkitBorderRadius: '100px',
        borderRadius: '100px',
        background: theme.palette.neutral?.grey8,
      },
      '& .content-container_back_button': {
        display: 'flex',
        justifyContent: 'flex-start',
      },

      '& .content-container_categories': {
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)',
        gap: 1,
      },
    },
  },
};
